import request from "./http";
import qs from 'qs'


// 	 * 工单部门管理
// /**
// 	 * 单位用户树
 export function getUserTree() {
    return request({
        url: "/user/getUserTree.do",
        method: "get",
    });
}

// /**
// 	 * 工单-添加部门
// departmentName
export function departmentSave(params) {
    return request({
        url: "/work/department/save",
        method: "post",
        params
    });
}
// /**
// 	 * 工单-删除部门
// departmentName
export function deleteDepartment(params) {
    return request({
        url: "/work/department/deleteById",
        method: "delete",
        params
    });
}

// /**
// 	 * 工单-修改部门名称
// departmentName
export function updateById(params) {
    return request({
        url: "/work/department/updateById",
        method: "put",
        params
    });
}


// /**
// 	 * 工单-查询所有部门
 export function departmentFindAllUser() {
    return request({
        url: "/work/department/findAllUser",
        method: "get",
    });
}

// /**
// 	 * 添加用户到对应的部门
// departmentId 部门id
// userId 用户Id
export function departmentSaveUserId(params) {
    return request({
        url: "/work/department/saveAllUser",
        method: "post",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
          data:qs.stringify(params)
    });
}

// /**
// 	* 批量移除部门用户
// departmentId 部门id
// userId 用户Id
export function departmentDeleteAllUserd(params) {
    return request({
        url: "/work/department/deleteAllUser",
        method: "delete",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
          params
    });
}


// /**
// 	 * 工单-查询任务节点
export function departmentOrderNode(params) {
    return request({
        url: "/work/department/orderNode",
        method: "get",
        params
    });
}

// /**
// 	 * 工单-领取任务
export function updateNodeUserId(params) {
    return request({
        url: "/work/department/updateNodeUserId",
        method: "put",
        params
    });
}